<div class="report-page-root-container  expense-details-report-component-container  ">
  <div class="page-content">
    <div class="page-header">
      <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" id="volume-analysis" style="width:27px">
        <path
          d="M7,25.08H5V13a3,3,0,0,1,3-3H23v2H8a1,1,0,0,0-1,1ZM45,38H43V29H41v9H7V35H21V33H3v2H5v3H3a1,1,0,0,0-1,1v2a5,5,0,0,0,5,5H41a5,5,0,0,0,5-5V39A1,1,0,0,0,45,38ZM24,10H46V25a3,3,0,0,1-3,3H27a3,3,0,0,1-3-3Zm5,5H41V13H29Zm0,4H41V17H29Zm0,4H41V21H29ZM46,5V8H24V5a3,3,0,0,1,3-3H43A3,3,0,0,1,46,5ZM31,4H28V6h3Zm5,0H33V6h3ZM11,27a1,1,0,0,0-1-1H6a1,1,0,0,0-1,1v5h6Zm3-6a1,1,0,0,0-1,1V32h6V22a1,1,0,0,0-1-1Z"
          data-name="33 Volume Analysis, Bar Chart, Bar Graph, Column Graph, Graphical Representation">
        </path>
      </svg> -->
      <img class="icon" src="assets/images/menu/svg/expense-details-report.svg" width="27">
      <div class="title">
        {{title}}
      </div>
      <div class="action-btn-container">
        @if(permission.can_export || permission.can_execute){
        <button mat-button color="accent" class="action-btn btn-export" (click)="exportClicked()"
          [disabled]="IsDownloading">
          <img class="download-icon"
            [src]="IsDownloading ? 'assets/images/animated/download/download-anim.svg' : 'assets/images/animated/download/download-no-anim.svg'">
          <span class="action-btn-title">Export</span>
        </button>
        }
        <!-- <button mat-flat-button class="action-btn btn-save" (click)="navigateToWeeklyReport()">View</button> -->
      </div>
    </div>
    <div class="page-details">
      <form class="edit-form" [formGroup]="editForm">
        <div class="detail-section">
          <div class="content-container">
            <div class="row">
              <mat-form-field>
                <mat-label>Period From</mat-label>
                <input matInput [matDatepicker]="pickerFrom" formControlName="period_from" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickerFrom></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_from')?.hasError('required') && editForm.get('period_from')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Period To</mat-label>
                <input matInput [matDatepicker]="pickerTo" formControlName="period_to"
                  [min]="editForm.get('period_from')?.value" placeholder="DD-MM-YYYY">
                <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
                <mat-datepicker #pickerTo></mat-datepicker>
                <mat-error
                  *ngIf="editForm.get('period_to')?.hasError('required') && editForm.get('period_to')?.touched">
                  Please select a date.
                </mat-error>
              </mat-form-field>
            </div>


            <div class="list-row expense-types">
              <div class="header" (click)="isExpandedExpense = !isExpandedExpense">
                <div class="title-container">
                  <span class="title">Expense Type</span> <span class="count" *ngIf="selectedExpenseTypeCount>0">[
                    {{selectedExpenseTypeCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedExpense">
                    <button type="button" class="list-action-button" mat-icon-button
                      (click)="$event.stopPropagation(); showSelectedExpenseTypeOnly = !showSelectedExpenseTypeOnly"
                      [matTooltip]="showSelectedExpenseTypeOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedExpenseTypeOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button" mat-icon-button
                      (click)="$event.stopPropagation(); toggleSelectAllExpenseType()" matTooltip="Select All/None">
                      <mat-icon>{{ getSelectAllIconExpenseType() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedExpense = !isExpandedExpense">
                    <mat-icon>{{ isExpandedExpense ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedExpense" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Expense Type" formControlName="expenseTypeFilter">
                      <button *ngIf="editForm.get('expenseTypeFilter')?.value" matSuffix mat-icon-button
                        aria-label="Clear" (click)="editForm.get('expenseTypeFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredExpenseTypeList">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <div class="list-row cashiers">
              <div class="header" (click)="isExpandedCashier = !isExpandedCashier">
                <div class="title-container">
                  <span class="title">Cashier</span> <span class="count" *ngIf="selectedCashierCount>0">[
                    {{selectedCashierCount}} ] </span>
                </div>
                <div class="toggle-action-container">
                  <ng-container *ngIf="isExpandedCashier">
                    <button type="button" class="list-action-button" mat-icon-button
                      (click)="$event.stopPropagation(); showSelectedCashierOnly = !showSelectedCashierOnly"
                      [matTooltip]="showSelectedCashierOnly ? 'Show All' : 'Show Selected Only'">
                      <mat-icon>{{ showSelectedCashierOnly ? 'visibility_off' : 'visibility' }}</mat-icon>
                    </button>
                    <button class="list-action-button" type="button" mat-icon-button
                      (click)="$event.stopPropagation(); toggleSelectAllCashier()" matTooltip="Select All/None">
                      <mat-icon>{{ getSelectAllIconCashier() }}</mat-icon>
                    </button>
                  </ng-container>
                  <button class="list-action-button"
                    (click)="$event.stopPropagation(); isExpandedCashier = !isExpandedCashier">
                    <mat-icon>{{ isExpandedCashier ? 'expand_less' : 'expand_more' }}</mat-icon>
                  </button>
                </div>
              </div>
              <div *ngIf="isExpandedCashier" class="list">
                <div class="item-list">
                  <div class="content-filter">
                    <mat-form-field style="width: 100%;" class="hide-subscript-wrapper">
                      <input matInput placeholder="Filter Cashier" formControlName="cashierFilter">
                      <button *ngIf="editForm.get('cashierFilter')?.value" matSuffix mat-icon-button aria-label="Clear"
                        (click)="editForm.get('cashierFilter')?.setValue('')">
                        <mat-icon>close</mat-icon>
                      </button>
                    </mat-form-field>
                  </div>
                  <div class="content">
                    <ng-container *ngFor="let item of filteredCashierListData">
                      <div class="list-item" (click)="item.selected = !item.selected">
                        <div class="name"><span>{{item.item.name}}</span></div>
                        <div class="selection">
                          <mat-checkbox [checked]="item.selected" (change)="item.selected = !item.selected"
                            (click)="$event.stopPropagation()">
                          </mat-checkbox>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>


            <!-- <div class="input-group">
              <div>
                Exclude sales details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>

              </div>

            </div> -->
            <!-- <div class="input-group">
              <div>
                Exclude expenses details
                <mat-checkbox></mat-checkbox>
              </div>
              <div>
              </div>

            </div> -->

          </div>
        </div>
      </form>
    </div>
  </div>
</div>